import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { BaseCompany } from '../../models/company.model';

@Component({
  selector: 'md-company-switcher',
  templateUrl: './company-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySwitcherComponent {
  @Output() selectCompanyHandler: EventEmitter<UUID> = new EventEmitter<UUID>();
  @Output()
  hideCompanySwitcherHandler: EventEmitter<void> = new EventEmitter<void>();
  @Input() currentCompanyId?: UUID;
  @Input() active?: boolean;
  @Input()
  get companies(): BaseCompany[] {
    return this.inputCompanies;
  }
  set companies(inputCompanies: BaseCompany[]) {
    this.inputCompanies = inputCompanies;
    this.filterQuery = this.filterQuery;
  }

  inputCompanies: BaseCompany[] = [];
  filteredCompanies: BaseCompany[] = [];
  query = '';

  get filterQuery(): string {
    return this.query;
  }

  set filterQuery(value: string) {
    this.query = value;
    const lowerCaseValue = value.toLowerCase();
    const filteredCompanies = this.companies
      ? this.companies.filter(company =>
          company.name.toLocaleLowerCase().includes(lowerCaseValue),
        )
      : [];
    this.filteredCompanies = filteredCompanies;
  }
  selectCompany(companyId: UUID) {
    this.selectCompanyHandler.emit(companyId);
    this.hideCompanySwitcher();
  }

  hideCompanySwitcher() {
    this.hideCompanySwitcherHandler.emit();
  }
}
